




















































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { TeamActivity, UserStat } from "../../types";
import moment from "moment";

@Component({
  filters: {
    moment: (date: string) => {
      return moment(date).format("MM/DD/YYYY");
    }
  }
})
export default class TeamActivityChart extends Vue {

  @Action private fetchCurrentTeamActivity!: () => any;
  @Getter private currentTeamID?: string;
  @Getter private currentTeamActivity!: TeamActivity[];
  
  private tableHeaderColor = "#eafbff"
  private activityCurrentPage: number = 1;
  private totalRows: number = 0;
  private filter: string | null = null;
  private isLoading = true;
  private headVariant: string | null = null;
  private onFiltered(filteredItems: any[]) {
    // Trigger pagination to update the number of buttons/pages due to filtering
    this.totalRows = filteredItems.length;
    this.activityCurrentPage = 1;
  }

  private rowClicked(item: TeamActivity) {
    let uid = item.uid;
    if(this.currentTeamID) {
      this.$router.push({
        name: "user",
        params: {
          teamID: this.currentTeamID,
          userID: uid
        }
      }); 
    }
  }

  @Watch("currentTeamActivity")
  private teamActivityData() {
    
    this.isLoading = false;
    
    if (this.currentTeamActivity) {
      this.totalRows = this.currentTeamActivity.length;
    } else {
      this.totalRows = 0
    }

    if(this.totalRows === 0) {
      this.headVariant = "empty"
    } else {
      this.headVariant = "item"
    }
  }

  private created() {
    
    if(this.currentTeamActivity!=null && this.currentTeamActivity.length>0) {
      this.teamActivityData()
    }

    this.fetchData();
  }

  @Watch("currentTeamID")
  private onCurrentTeamIdChanged(newVal: string, oldVal: string) {
    if (newVal && newVal !== oldVal) {
      this.isLoading = true;
      this.filter = null;
      this.fetchData();
    }
  }

  private fetchData() {
    this.fetchCurrentTeamActivity();
  }

  private fields: any = [
    {
      key: "name",
      label: "Name",
      sortable: true,
    },
    {
      key: "averageScore",
      label: "Orai Score",
      sortable: true,
    },
    {
      key: "lastRecordingDate",
      label: "Last Session",
      sortable: true,
    }
  ];
}
